import PhoneNumber, { CountryCode } from 'libphonenumber-js'

import Logger from 'core/utils/Logger'

interface IFormatPhoneNumber {
  number?: string
  countryCode?: string
}

export const formatPhoneNumber = ({ number, countryCode }: IFormatPhoneNumber) => {
  if (!number) {
    return undefined
  }

  if (countryCode) {
    try {
      const parsedPhoneNumber = PhoneNumber(number, countryCode as CountryCode)
      return parsedPhoneNumber?.formatInternational()
    } catch (error) {
      Logger.error('Invalid phone number:', error)
      return number
    }
  }
  return number
}
